import {Typography, useTheme} from '@mui/material';
import {QueryParamsEnum} from 'presentation/constants';
import Icon from 'presentation/icons';
import {useQueryParams} from 'presentation/pages';
import React from 'react';
import {formatText} from 'presentation/utils';
import {OptionType} from '../../types';
import {StyledList, StyledListItem} from './styles';
import {AutocompleteMobileOptionsProps} from './types';
import {useIsAutocompleteFocusedStore} from '../../store/useIsAutocompleteFocusedStore';

export default function AutocompleteMobileOptions({options}: AutocompleteMobileOptionsProps) {
	const theme = useTheme();
	const {setSearchParams} = useQueryParams();
	const setIsAutocompleteFocused = useIsAutocompleteFocusedStore(
		state => state.setIsAutocompleteFocused,
	);

	function handleChangeSearchParams(newValue: string, autocompleteQueryParam?: string) {
		setIsAutocompleteFocused(false);
		setSearchParams(
			prev => {
				prev.set(QueryParamsEnum.SEARCH_QUERY, newValue);
				prev.delete(QueryParamsEnum.SEARCH_BY_LETTER);
				if (autocompleteQueryParam)
					prev.set(QueryParamsEnum.AUTOCOMPLETE_QUERY, autocompleteQueryParam);

				return prev;
			},
			{
				replace: true,
			},
		);
	}

	return (
		<StyledList>
			{options
				?.toSorted((current, next) => current.label.localeCompare(next.label))
				.map((option: OptionType) => (
					<StyledListItem
						key={option.id}
						onClick={() => handleChangeSearchParams(option.label, String(option.id))}>
						<Typography variant="body1" color="text.primary">
							{formatText(option.label)}
						</Typography>
						<Icon name="arrow-right-filled" color={theme.brand.primary.blue} />
					</StyledListItem>
				))}
		</StyledList>
	);
}
